import {GetFaqUrl} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetFaqUrl} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetFaqUrl = (): GetFaqUrl =>
	new RemoteGetFaqUrl(makeBFFApiUrl(ExternalLinkPoint.faq), makeAuthorizeHttpClientDecorator());

export const makeMockedFaqUrl = (): GetFaqUrl => ({
	get: async () => ({
		url: '/mocks/test-page-1.html',
	}),
});
